export const STATUS = Object.freeze({
    SUCCESS: 'success',
    ERROR:   'error',
});
